import * as React from "react";
import { Outlet, useRouteLoaderData } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import type { RootLoader } from "@/types/RootLoader";
import { useSentryUser } from "@tiny/sentry/hooks";
import ZohoSalesIQ from "@/components/ZohoSalesIQ/ZohoSalesIQ";
import { ProviderConfigProvider } from "@/providers/ProviderConfigContext";
import { getThemeForProvider } from "@/providers/theme";

function RootRoute() {
  const { accountInfo, userStatus } = useRouteLoaderData("root") as RootLoader;
  const { userEmail, firstName, lastName, phoneNumber, site } =
    accountInfo ?? {};
  useSentryUser({ email: userEmail, username: userEmail, site });

  // Overrides the outer, URL-guessed theme from ProviderThemeProvider with
  // the one the account API actually says — same reasoning as
  // ProviderConfigProvider below: sessionStorage/the URL can't be trusted.
  // userStatus.provider, not accountInfo.providerIdentifier — see
  // ProviderConfigContext for why that field doesn't hold the provider type.
  const theme = React.useMemo(
    () => getThemeForProvider(userStatus?.provider),
    [userStatus?.provider]
  );

  return (
    <ProviderConfigProvider>
      <ThemeProvider theme={theme}>
        <Outlet />
        <ZohoSalesIQ
          visitorInfo={{
            name: `${firstName} ${lastName}`,
            email: userEmail || "",
            contactnumber: phoneNumber || "",
          }}
        />
      </ThemeProvider>
    </ProviderConfigProvider>
  );
}

export default RootRoute;
export { rootLoader } from "./loader";
